var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77583 2.97985L5.0727 1.61523C5.37198 1.30033 5.67132 0.880568 5.97065 0.56567C5.97065 0.460701 5.17236 1.40536 4.47407 2.03515L3.67597 2.87487C3.4765 3.0848 3.77583 2.87489 3.77583 2.97985Z",
    fill: "#F1F6EF",
    stroke: "white",
    strokeWidth: 0.5774,
    strokeMiterlimit: 5.0497
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77833 2.18213C3.17735 2.49703 3.37689 2.91688 3.57643 3.02185C3.07762 2.49702 1.28194 0.502686 1.18214 0.502686C1.0824 0.502686 2.17972 1.44736 2.77833 2.18213Z",
    fill: "#F1F6EF",
    stroke: "white",
    strokeWidth: 0.5774,
    strokeMiterlimit: 5.0497
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductArrow);
export default __webpack_public_path__ + "static/media/product-arrow.90a8801e1c4d5df01c16f76d558e0003.svg";
export { ForwardRef as ReactComponent };